export default "__VITE_ASSET__BwNkTsya__"